<template>
  <div class="h-full overflow-auto">
    <div
      class="fixed top-0 left-0 z-[9999] w-full h-full md:hidden mobileMenu"
      id="menuPannel"
      :class="{
        'pointer-events-none opacity-0 duration-300': !pannelIsVisible,
        pannelOpened: pannelIsVisible,
      }"
    >
      <SwipperView
        v-slot="{ data }"
        :nbTabs="2"
        :defaultTab="1"
        ref="tabsContainer"
        :loop="false"
        :autoPlay="false"
        @tabChanged="
          index => {
            onTabChanged(index)
          }
        "
      >
        <div class="h-full" v-if="data.position == 0">
          <div class="absolute w-full h-full -translate-x-full bg-white"></div>
          <div
            class="absolute w-[150vw] h-full bg-black bg-opacity-50 duration-300 translate-x-[50vw]"
          ></div>
          <div
            class="absolute w-full h-full right-0 duration-300"
            @click="hidePannel"
          ></div>
          <div class="w-[80%] bg-white h-full relative">
            <MenuPannelContent @navClicked="hidePannel" />
          </div>
        </div>
      </SwipperView>
    </div>

    <div
      class="h-full hidden md:block desktopMenu"
      @mouseenter="hovering = true"
      @mouseleave="hovering = false"
    >
      <div
        class="bg-white h-full relative group duration-300"
        :class="hovering ? 'w-[20rem]' : 'w-24'"
      >
        <MenuPannelContent :collapsed="!hovering" @navClicked="() => {}" />
      </div>
    </div>

    <EventListener
      :events="CUSTOM_EVENTS.TOGGLE_MENU"
      v-on:[CUSTOM_EVENTS.TOGGLE_MENU]="togglePannel"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import MenuPannelContent from './MenuPannelContent.vue'
import EventListener from '@/events/EventListener.vue'
import { CUSTOM_EVENTS } from '@/project/configs/customConstants'
import SwipperView from '@/presentation/components/tab/SwipperView.vue'

export default defineComponent({
  name: 'MenuPannel',
  components: { SwipperView, MenuPannelContent, EventListener },
  props: {},
  data() {
    return {
      eventsIds: [],
      pannelIsVisible: false,
      hovering: false,
      CUSTOM_EVENTS,
    }
  },
  mounted() {
    // const id = Events.handleEvent("open_sidebar_menu", this.openPannel);
    // this.eventsIds.push(id);
  },
  methods: {
    togglePannel() {
      if (this.pannelIsVisible) this.hidePannel()
      else this.openPannel()
    },
    openPannel() {
      this.$refs.tabsContainer?.slideTo(0)
    },
    onTabChanged(index) {
      if (index == 0) this.pannelIsVisible = true
      else
        setTimeout(() => {
          this.pannelIsVisible = false
        }, 300)
    },
    hidePannel() {
      this.$refs.tabsContainer?.slideTo(1)
    },
  },
  watch: {},
})
</script>
